import { Component, EventEmitter, ViewChild, ViewChildren, ElementRef, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { DatatableClickEvent } from '@basis/angular-components';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TabViewModule } from 'primeng/primeng';
import { FieldsetModule } from 'primeng/primeng';
import { MenuItem } from 'primeng/primeng';
import { SelectItem } from 'primeng/primeng';
import { PadraoService } from '../../service/padrao.service';
import { Message } from 'primeng/primeng';
import { SliderModule } from 'primeng/primeng';
import { CrudLotacaoEtapa1Component } from '../';
import { CrudLotacaoEtapa2Component } from '../';
import { BaseCrudComponent } from "../../base";
import { environment } from 'environments/environment';
import { Lotacao } from '../../entity/lotacao.model'
import { ValidCpfORCnpj, ValidCamposNumbVirgula, ValidCamposNan } from '../../util/custom.validators';

@Component({
    selector: 'lotacao-crud',
    templateUrl: 'lotacao-crud.component.html'
})

export class CrudLotacaoComponent extends BaseCrudComponent {
    controllerName = 'lotacao';

    PaiOptions: SelectItem[] = [];
    UFOptions: SelectItem[] = [];
    uploadedFiles: any[] = [];

    cadastro = this.formBuilder.group({
        nome: [null, [Validators.required,Validators.maxLength(80)]],
        sigla: [null, [Validators.required,Validators.maxLength(20)]],
        data_inclusao: new Date,
        id_situacao: [1],
        
        cnpj: [null, [Validators.required,ValidCpfORCnpj]],
        cep: [null, [Validators.required]],
        endereco: [null, [Validators.required,Validators.maxLength(100)]],
        numero: [null, [Validators.required,Validators.min(1),ValidCamposNumbVirgula]],
        complemento: [null, [Validators.maxLength(100)]],
        bairro: [null, [Validators.required,Validators.maxLength(100)]],
        id_uf: [null, [Validators.required]],
        cidade: [null, [Validators.required,Validators.maxLength(100)]],


        id_lotacao_pai: [null, [Validators.required]],
        id: [null]
    });

    init() {
        this.service.ListarTodos('combo/lotacao').subscribe(
            data => {
                this.PaiOptions = data;
            }
        );
        this.service.ListarTodos('combo/uf').subscribe(
            data => {
                this.UFOptions = data
            }
        );

        this.cadastro.get('cep').valueChanges.subscribe(x => {
            var cep = this.limpaCaracterEspecial(x);
            if(cep.length == 8){
                
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.service.ObterCep('cep/buscaCep',cep).subscribe(y => {
                    if(y != null){
                        this.cadastro.get('id_uf').setValue(y.id_uf);
                        this.cadastro.get('endereco').setValue(y.logradouro); 
                        this.cadastro.get('complemento').setValue(y.complemento); 
                        this.cadastro.get('bairro').setValue(y.bairro); 
                        this.cadastro.get('cidade').setValue(y.municipio);
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    }else{
                        this.cadastro.get('id_uf').setValue(null);
                        this.cadastro.get('endereco').setValue(null);
                        this.cadastro.get('complemento').setValue(null);
                        this.cadastro.get('bairro').setValue(null);
                        this.cadastro.get('cidade').setValue(null);
                        this.cadastro.get('cep').setErrors({validators:"Cep Inválido"});
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                    }

                });
            }
        })
        super.init();
        super.afterLoad();
    }

    afterLoad() {
        if (this.acao != "cadastrar") {
            if (this.obj.anexo_lotacao != null) {
                this.obj.anexo_lotacao.forEach(x => {
                    x.show = true;
                    x.nome_arquivo = x.nome_arquivo;
                    this.uploadedFiles.push(x);
                });
            }

            this.cadastro.controls['sigla']
                .setValue(this.cadastro.value.sigla != null ? this.cadastro.value.sigla.toUpperCase().replace(" ", "") : '');
            this.cadastro.patchValue(this.obj);
        }
    }

    @HostListener('keyup') UpperCase() {
        if (this.cadastro.value.sigla !== undefined) {
            this.cadastro.controls['sigla']
                .setValue(this.cadastro.value.sigla != null ? this.cadastro.value.sigla.toUpperCase().replace(" ", "") : '');
        }
    }

    finalizar(event: any) {

        var dados: any = Object.assign({}, this.cadastro.value);
        dados.anexo_lotacao = [];

        dados.cnpj = this.limpaCaracterEspecial(dados.cnpj);
        dados.cep = this.limpaCaracterEspecial(dados.cep);

        this.uploadedFiles.forEach(item => {
            item.nome_arquivo = item.nome_arquivo;
            dados.anexo_lotacao.push(item)
        });
        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: `Atenção! Ao confirmar esta operação, a lotação será ${this.acao == 'cadastrar' ? 'salva' : 'atualizada'} na base de dados.
                Deseja realmente confirmar esta operação?`,
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                this.acao === 'cadastrar' ?
                    this.service.Adicionar(this.controllerName, dados).subscribe(
                        sucess => {
                            sessionStorage.setItem("msg", "Registro salvo com sucesso.");
                            this.router.navigate(['../'], { relativeTo: this.activatedRoute });
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                        },
                        err => {
                            this.observableUtilPanelDoc.setBlockedPanel(false);
                            this.showMsg('warn', 'Mensagem de Erro', `Erro ao gravar. ${err._body}`)
                    }) :
                    this.service.Atualizar(this.controllerName, dados)
                        .subscribe(
                            sucess => {
                                sessionStorage.setItem("msg", "Registro atualizado com sucesso.");
                                this.router.navigate(['../../'], { relativeTo: this.activatedRoute });
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                            },
                            err => {
                                this.observableUtilPanelDoc.setBlockedPanel(false);
                                super.showMsg('warn', 'Mensagem de Erro', `Erro ao atualizar. ${err._body}`)
                        });
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/lotacao/crud/lotacao-crud.component.ts